<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>
          Ruta de Cobros
          {{ form.numero_documento === "" ? "" : "- " + form.numero_documento }}
        </h3>
        <label>
          <div v-if="form.id" :class="getEstadoColor(form.estado)">
            ESTADO:
            <strong>{{ getEstadoParse(form.estado) }}</strong>
          </div>
        </label>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="limpiar" type="button" class="btn-secondary">
            <i class="fa fa-trash"></i><span>Limpiar</span>
          </button>
          <button v-if="(rutaCobros || form.id) && form.estado == 'A' && puedeCerrar && !esFechaFutura"
            @click="aperturaCierrerRuta('C')" type="button" class="btn-primary">
            <i class="fa fa-lock"></i><span>Cerrar</span>
          </button>
          <button v-if="(rutaCobros || form.id) && form.estado == 'C' && puedeAbrir" @click="aperturaCierrerRuta('A')"
            type="button" class="btn-primary">
            <i class="fa fa-unlock"></i><span>Abrir</span>
          </button>
          <button v-if="(rutaCobros || form.id) && form.estado == 'A'" @click="actualizarPrestamos" type="button"
            class="btn-warning">
            <i class="fa fa-refresh"></i><span>Actualizar</span>
          </button>
          <button v-show="rutaCobros == null && !form.id" @click="generar" type="generar" class="btn-primary">
            <i class="fa fa-search"></i><span>Generar</span>
          </button>
          <button v-if="form.estado == 'A' && ((!form.id && puedeCrear) || (form.id && puedeEditar))"
            @click="confirmarGuardar" type="button" class="btn-success">
            <i class="fa fa-save"></i><span>Guardar</span>
          </button>
          <button v-if="rutaCobros || form.id" @click="abrirModalAuditoria" class="btn-secondary">
            <i class="fa fa-list"></i><span>Auditoría</span>
          </button>
          <button @click="imprimirCierre('P')" v-show="rutaCobros || form.id" type="button" class="btn-danger">
            <i class="fa fa-file-pdf-o"></i><span>Imprimir cierre</span>
          </button>
          <button @click="imprimirCierre('E')" v-show="rutaCobros || form.id" type="button" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Imprimir cierre</span>
          </button>
          <button @click="imprimirRecibos" v-show="rutaCobros || form.id" type="button" class="btn-info">
            <i class="fa fa-file"></i><span>Imprimir recibos</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Información de ruta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker id="fecha" v-model="form.fecha" locale="es" no-label only-date
                  button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                  label="Seleccione una fecha..." :disabled="form.prestamos.length > 0" />
                <label>Fecha</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2" :class="{
              'select2--disabled': form.prestamos.length > 0,
            }">
              <div class="select2-field">
                <v-select @input="inputRuta" id="ruta_id" v-model="selectedRuta" :options="rutas"
                  @search="onSearchRutas" label="descripcion"></v-select>
                <label for="ruta">Ruta</label>
                <span v-if="errores.ruta_id" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.ruta_id[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2" :class="{
              'select2--disabled': rutaCobros != null || form.id,
            }">
              <div class="select2-field">
                <v-select placeholder="Seleccione..." @search="onSearchRecaudadores" @input="inputRecaudador"
                  id="recaudador_id" :options="recaudadores" label="nombre" v-model="selectedRecaudador"></v-select>
                <label for="recaudador_id">Recaudador</label>
                <span v-if="errores.recaudador_id" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.recaudador_id[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Clientes <template v-if="form.prestamosFilter.length > 0">({{ form.prestamosFilter.length }})</template>
        </h5>
        <div class="card__controls">
          <div class="form-field">
            <input-field id="filtro_cliente" v-if="form.id" v-model="form.search" @keyup="search"
              placeholder="Realice una búsqueda..." stretch>
              <span>Buscar:</span>
            </input-field>
          </div>
        </div>
      </div>
      <div class="card__content">
        <div class="d-flex jc-between mb-2">
          <div>
            <button v-if="form.id && form.estado == 'A' && puedeCrearPrestamos && !esFechaFutura" title="Nuevo préstamo"
              type="button" class="btn-primary" @click="abrirModalPrestamo(null, 'NR')">
              <i class="fa fa-plus"></i><span>Préstamo</span>
            </button>
            <button v-if="form.estado == 'A' && form.id && form.saldada === 'N' && puedeSaldar && !esFechaFutura"
              type="button" class="btn-success" @click="saldar">
              <i class="fa fa-money"></i><span>Saldar</span>
            </button>
            <button
              v-if="form.estado == 'A' && form.id && form.saldada === 'S' && puedePagarDominicalRuta && !esFechaFutura"
              type="button" class="btn-secondary" @click="abrirModalPagarDominicalRuta">
              <i class="fa fa-handshake-o"></i><span>Dominical</span>
            </button>
            <button v-if="form.estado == 'A' && form.id && puedeAbonarPrestamosAgendados && !esFechaFutura"
              type="button" class="btn-warning" @click="mostrarCreditosAgendados">
              <i class="fa fa-address-book"></i><span>Créditos agendados</span>
            </button>
            <button
              v-if="form.estado == 'A' && form.id && puedeAsignarFechaMasiva && !esFechaFutura && form.saldada === 'S'"
              type="button" class="btn-primary" @click="mostrarModalFechaMasiva">
              <i class="fa fa-calendar-o"></i><span>Asignar fecha masiva</span>
            </button>
          </div>
          <div class="indicadores" v-show="form.prestamosFilter.length > 0">
            <div class="indicadores__item">
              <div class="indicadores__item__color">
                <div class="bg-atraso"></div>
              </div>
              <div class="indicadores__item__title">
                <span>Atraso</span>
              </div>
            </div>
            <div class="indicadores__item">
              <div class="indicadores__item__color">
                <div class="bg-dominical"></div>
              </div>
              <div class="indicadores__item__title">
                <span>Dominical</span>
              </div>
            </div>
            <div class="indicadores__item">
              <div class="indicadores__item__color">
                <div class="bg-renovacion"></div>
              </div>
              <div class="indicadores__item__title">
                <span>Renovación</span>
              </div>
            </div>
            <div class="indicadores__item">
              <div class="indicadores__item__color">
                <div class="bg-refinanciacion"></div>
              </div>
              <div class="indicadores__item__title">
                <span>Refinanciación</span>
              </div>
            </div>
            <div class="indicadores__item">
              <div class="indicadores__item__color">
                <div class="bg-abonos"></div>
              </div>
              <div class="indicadores__item__title">
                <span>Abonos</span>
              </div>
            </div>
            <div class="indicadores__item">
              <div class="indicadores__item__color">
                <div class="bg-deposito"></div>
              </div>
              <div class="indicadores__item__title">
                <span>Depósitos</span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th>Cliente</th>
                <th>Cédula</th>
                <th>Crédito</th>
                <th>CC</th>
                <th>CF</th>
                <th>PD</th>
                <th>AT</th>
                <th>ST</th>
                <th>Valor de cuota</th>
                <th>T. Pagado</th>
                <th>Saldo</th>
                <th v-if="form.id && !esFechaFutura && form.estado == 'A'">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(prestamo, index) in form.prestamosFilter" :key="prestamo.prestamo_id + '-' + index"
                :class="getColorP(prestamo)">
                <th>{{ index + 1 }}</th>
                <td>
                  <button title="Amortizaciones" type="button" class="btn-info btn--text"
                    @click="abrirModalAmortizaciones(index)">
                    <i class="fa fa-table"></i>
                  </button>
                </td>
                <td>
                  {{ prestamo.cliente.descripcion }}
                </td>
                <td>
                  {{ prestamo.cliente.numero_identificacion }}
                </td>
                <td>
                  {{ prestamo.numero_documento }}
                </td>
                <td>
                  {{ prestamo.cuotas_canceladas }}
                </td>
                <td>
                  {{ prestamo.cuotas_faltantes }}
                </td>
                <td>
                  {{ prestamo.pagos_dominicales }}
                </td>
                <td>
                  {{ prestamo.atrasos }}
                </td>
                <td>
                  {{ prestamo.estado_descripcion }}
                </td>
                <td>
                  {{ moneyFormat(prestamo.valor_cuota, 2) }}
                </td>
                <td>
                  {{ moneyFormat(prestamo.total_pagado_dia, 2) }}
                </td>
                <td>
                  {{ moneyFormat(prestamo.saldo, 2) }}
                </td>
                <td v-if="form.id && !esFechaFutura && form.estado == 'A' && prestamo.cliente_ruta_cobro_id">
                  <button v-if="!prestamo.atraso && puedeAbonar" title="Abonar" type="button"
                    class="btn-success btn--text" @click="abrirModalAbonos(index)">
                    <i class="fa fa-money"></i>
                  </button>
                  <button v-if="!prestamo.atraso && puedePagarDominical"
                    :title="prestamo.observacion_dominical ? 'Ver observación' : 'Dominical'" type="button"
                    class="btn-secondary btn--text" @click="abrirModalDominical(index)">
                    <i :class="['fa', prestamo.observacion_dominical ? 'fa-eye' : 'fa-handshake-o']"></i>
                  </button>
                  <button v-if="prestamo.atraso && puedeNoPagar" title="Cancelar no pago" type="button"
                    class="btn-success btn--text" @click="revertirAtraso(index)">
                    <i class="fa  fa-arrow-left"></i>
                  </button>
                  <!-- <button v-if="!prestamo.atraso && puedeNoPagar" title="No pago" type="button" class="btn-danger btn--text"
                    @click="registrarAtraso(index)"> -->
                  <button v-if="!prestamo.atraso && puedeNoPagar && !prestamo.observacion_dominical" title="No pago"
                    type="button" class="btn-danger btn--text" @click="abrirModalAtraso(index)">
                    <i class="fa fa-ban"></i>
                  </button>
                  <button
                    v-if="!prestamo.atraso && prestamo.saldo > 0 && puedeRenovar && !prestamo.observacion_dominical"
                    title="Renovación" type="button" class="btn-primary btn--text"
                    @click="abrirModalPrestamo(index, 'RN')">
                    <i class="fa fa-repeat"></i>
                  </button>
                  <button
                    v-if="!prestamo.atraso && prestamo.saldo > 0 && puedeRefinanciar && !prestamo.observacion_dominical"
                    title="Refinanciación" type="button" class="btn-warning btn--text"
                    @click="abrirModalPrestamo(index, 'RF')">
                    <i class="fa fa-refresh"></i>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr v-show="form.prestamosFilter.length === 0">
                <td colspan="12">
                  <strong> No se ha encontrado préstamos. </strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Cuota promedio</th>
                <th>% Cobrado</th>
                <th>Debería</th>
                <th>T. Pagos</th>
                <th>T. No Pagos</th>
                <th>T. Dominicales</th>
                <th>Total recibos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ moneyFormat(cuotaPromedio, 2) }}
                </td>
                <td>
                  {{ porcCobrado }} %
                </td>
                <td>
                  {{ moneyFormat(form.deberia, 2) }}
                </td>
                <td>
                  {{ moneyFormat(totalPagos, 2) }}
                </td>
                <td>
                  {{ totalNoPagos }}
                </td>
                <td>
                  {{ totalDominicales }}
                </td>
                <td>
                  {{ totalRecibos }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-3 mt-3">
        <div class="card">
          <!-- <div class="card__title">
            <h5>Clientes</h5>
          </div> -->
          <div class="card__content">
            <div class="table-responsive">
              <table>
                <tbody>
                  <tr>
                    <td><b>Total crédito</b></td>
                    <td>
                      {{ moneyFormat(form.total_credito, 2) }}
                    </td>
                  </tr>
                  <tr>
                    <td><b>Base</b></td>
                    <td>
                      <div class="form-field">
                        <input-field stretch vMoney :format="money" id="total_efectivo" placeholder="##.##"
                          v-model="form.total_efectivo" :disabled="form.estado != 'A'">
                        </input-field>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><b>Vale</b></td>
                    <td>
                      <div class="form-field">
                        <input-field stretch vMoney :format="moneyNegative" id="vale_base" placeholder="##.##"
                          v-model="form.vale_base" readonly>
                        </input-field>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><b>Total depósito</b></td>
                    <td>
                      <div class="form-field">
                        <input-field stretch vMoney :format="money" id="total_deposito" placeholder="##.##"
                          v-model="form.total_deposito" :disabled="form.estado != 'A'">
                        </input-field>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Total microseguro ({{ parametros ? parametros.porc_microseguro : 2 }}%)</b>
                    </td>
                    <td>
                      <input-field vMoney :format="money" id="total_microseguro" v-model="form.total_microseguro"
                        placeholder="##.##" :disabled="form.estado != 'A'">
                      </input-field>
                    </td>
                    <!-- <td>
                      {{ moneyFormat(form.total_microseguro, 2) }}
                    </td> -->
                  </tr>
                  <tr>
                    <td><b>Subtotal</b></td>
                    <td>{{ moneyFormat(subtotal, 2) }}</td>
                  </tr>
                  <tr>
                    <td><b>Total a recibir</b></td>
                    <td>{{ moneyFormat(
                      subtotal +
                      form.prestamo_efectivo +
                      form.prestamo_deposito +
                      form.prestamo_transferencia
                      , 2) }}</td>
                  </tr>
                  <tr>
                    <td><b>Total entregado</b></td>
                    <td>
                      <input-field stretch vMoney :format="money" id="total_entregado" v-model="form.total_entregado"
                        placeholder="##.##" :disabled="form.estado != 'A'">
                      </input-field>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex ai-center jc-between">
                        <b>Gasto</b>
                        <button v-if="form.gasto > 0" type="button" title="Observación" class="btn-secondary btn--text"
                          @click="openModalGasto">
                          <i class="fa fa-eye"></i>
                        </button>
                      </div>
                    </td>
                    <td>
                      <div class="form-field">
                        <input-field stretch vMoney :format="money" id="gasto" v-model="form.gasto" placeholder="##.##"
                          :disabled="form.estado != 'A'">
                        </input-field>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex ai-center jc-between">
                        <b>Vale</b>
                        <button type="button" title="Observación de vale" class="btn-secondary btn--text"
                          @click="openModalObsVale">
                          <i class="fa fa-eye"></i>
                        </button>
                      </div>
                    </td>
                    <td>{{ vale }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 mt-3" v-if="form.id && !esFechaFutura">
        <div class="card">
          <div class="card__title">
            <h5>Cuotas pagadas</h5>
          </div>
          <div class="card__content">
            <div class="table-responsive">
              <table>
                <tbody>
                  <tr>
                    <td><b>Total efectivo</b></td>
                    <td>{{ moneyFormat(form.prestamo_efectivo, 2) }}</td>
                  </tr>
                  <tr>
                    <td><b>Total depósito</b></td>
                    <td>{{ moneyFormat(form.prestamo_deposito, 2) }}</td>
                  </tr>
                  <tr>
                    <td><b>Total transferencia</b></td>
                    <td>{{ moneyFormat(form.prestamo_transferencia, 2) }}</td>
                  </tr>
                  <tr>
                    <td><b>Total recaudado</b></td>
                    <td>
                      {{
                        moneyFormat(
                          form.prestamo_efectivo +
                          form.prestamo_deposito +
                          form.prestamo_transferencia,
                          2
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-3" v-if="form.prestamosRN.length > 0">
        <div class="card">
          <div class="card__title">
            <h5>Renovaciones ({{ form.prestamosRN.length }})</h5>
          </div>
          <div class="card__content">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Cliente</th>
                    <th>Cédula</th>
                    <th>Crédito</th>
                    <th>Préstamo referencia</th>
                    <th>Valor de cuota</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(prestamoRN, indexRN) in form.prestamosRN" :key="prestamoRN.prestamo_id + '-' + indexRN">
                    <th>{{ indexRN + 1 }}</th>
                    <td>
                      {{ prestamoRN.cliente.descripcion }}
                    </td>
                    <td>
                      {{ prestamoRN.cliente.numero_identificacion }}
                    </td>
                    <td>
                      {{ prestamoRN.numero_documento }}
                    </td>
                    <td>
                      {{ prestamoRN.prestamo_ref.numero_documento }}
                    </td>
                    <td>
                      {{ moneyFormat(prestamoRN.valor_cuota, 2) }}
                    </td>
                    <td>
                      {{ moneyFormat(parseFloat(prestamoRN.total_pagado) + parseFloat(prestamoRN.saldo), 2) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-3" v-if="form.prestamosRF.length > 0">
        <div class="card">
          <div class="card__title">
            <h5>Refinanciamientos ({{ form.prestamosRF.length }})</h5>
          </div>
          <div class="card__content">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Cliente</th>
                    <th>Cédula</th>
                    <th>Crédito</th>
                    <th>Préstamo referencia</th>
                    <th>Valor de cuota</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(prestamoRF, indexRF) in form.prestamosRF" :key="prestamoRF.prestamo_id + '-' + indexRF">
                    <th>{{ indexRF + 1 }}</th>
                    <td>
                      {{ prestamoRF.cliente.descripcion }}
                    </td>
                    <td>
                      {{ prestamoRF.cliente.numero_identificacion }}
                    </td>
                    <td>
                      {{ prestamoRF.numero_documento }}
                    </td>
                    <td>
                      {{ prestamoRF.prestamo_ref.numero_documento }}
                    </td>
                    <td>
                      {{ moneyFormat(prestamoRF.valor_cuota, 2) }}
                    </td>
                    <td>
                      {{ moneyFormat(parseFloat(prestamoRF.total_pagado) + parseFloat(prestamoRF.saldo), 2) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-3" v-if="form.prestamosNR.length > 0">
        <div class="card">
          <div class="card__title">
            <h5>Nuevos ({{ form.prestamosNR.length }})</h5>
          </div>
          <div class="card__content">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Cliente</th>
                    <th>Cédula</th>
                    <th>Crédito</th>
                    <th>Valor de cuota</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(prestamoNR, indexNR) in form.prestamosNR" :key="prestamoNR.prestamo_id + '-' + indexNR">
                    <th>{{ indexNR + 1 }}</th>
                    <td>
                      {{ prestamoNR.cliente.descripcion }}
                    </td>
                    <td>
                      {{ prestamoNR.cliente.numero_identificacion }}
                    </td>
                    <td>
                      {{ prestamoNR.numero_documento }}
                    </td>
                    <td>
                      {{ moneyFormat(prestamoNR.valor_cuota, 2) }}
                    </td>
                    <td>
                      {{ moneyFormat(parseFloat(prestamoNR.total_pagado) + parseFloat(prestamoNR.saldo), 2) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="modalAbonos" scrollable reset adaptive resizable height="auto" width="50%" clickToClose>
      <modal-abono :fecha-ruta-cobro="form.fecha" v-model="selectedPrestamo" @cerrar="$modal.hide('modalAbonos')"
        @input="inputModalAbono">
      </modal-abono>
    </modal>
    <modal name="prestamo" scrollable reset adaptive resizable height="auto" width="65%" :clickToClose="false">
      <prestamo :porcInteres="parametros ? parametros.porc_interes : null"
        :cuotas="parametros ? parametros.cuotas : null" puedeCambiarInteres
        :prestamoRefId="selectedPrestamo ? selectedPrestamo.prestamo_id : ''" :tipoPrestamo="tipoPrestamo"
        :ruta="selectedRuta" @cerrar="$modal.hide('prestamo')" @guardar="guardarPrestamo"
        :valor-pago-rf="selectedPrestamo ? selectedPrestamo.pago.valor : 0"
        :fecha-ruta-cobro="form.fecha ? form.fecha : ''">
      </prestamo>
    </modal>
    <modal name="dominical" scrollable reset adaptive resizable height="auto" width="50%" clickToClose>
      <observacion-dominical v-model="selectedPrestamo" :errores="errores" @cerrar="$modal.hide('dominical')"
        @input="inputDominical"></observacion-dominical>
    </modal>
    <modal name="modalAtraso" scrollable reset adaptive resizable height="auto" width="50%" clickToClose>
      <modal-atraso v-model="selectedPrestamo" :porcentajeMulta="parametros.porc_multa" :errores="errores"
        @cerrar="$modal.hide('modalAtraso')" @input="registrarAtraso"></modal-atraso>
    </modal>
    <modal name="auditorias" scrollable reset adaptive resizable height="auto" width="70%" clickToClose>
      <auditoria modulo="RC" :identificacion="form.numero_documento"></auditoria>
    </modal>
    <modal name="amortizaciones" scrollable reset adaptative resizable height="auto" width="50%" clickToClose>
      <amortizaciones v-model="selectedPrestamo" @cerrar="$modal.hide('amortizaciones')"></amortizaciones>
    </modal>
    <modal name="gasto" scrollable reset adaptive resizable height="auto" width="50%" clickToClose>
      <div class="layout">
        <div class="layout__header">
          <div class="layout__title">
            <h3>
              Observación Gasto
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <textarea-field placeholder="Escriba una observación" id="observacion_gasto" name="observacion_gasto"
              v-model="form.observacion_gasto">
              <span>Observaciones</span>
            </textarea-field>
          </div>
        </div>
        <div class="modal-buttons">
          <button class="btn-danger btn--text" @click="$modal.hide('gasto')">
            <i class="fa fa-times"></i><span>Cerrar</span>
          </button>
        </div>
      </div>
    </modal>
    <modal name="clientes-agendados" scrollable reset adaptive resizable height="auto" width="70%"
      :clickToClose="false">
      <creditos-agendados :ruta-cobro-id="form.id" @cerrar="$modal.hide('clientes-agendados')"
        @guardar="agregarCreditosAgendados"></creditos-agendados>
    </modal>
    <modal name="fechaMasiva" scrollable reset adaptive resizable height="auto" width="30%" clickToClose>
      <div class="layout">
        <div class="layout__header">
          <div class="layout__title">
            <h3>
              Actualizar masivamente fecha de próximo pago
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker id="fecha_masiva" v-model="obj.fecha_masiva" locale="es" no-label only-date
                  button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                  label="Seleccione una fecha..." />
                <label>Fecha</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-buttons">
          <button @click="asignarFechaMasiva" class="btn-success">
            <i class="fa fa-save"></i><span>Guardar</span>
          </button>
          <button class="btn-danger btn--text" @click="$modal.hide('fechaMasiva')">
            <i class="fa fa-times"></i><span>Cerrar</span>
          </button>
        </div>
      </div>
    </modal>
    <modal name="obs-vale" scrollable reset adaptive resizable height="auto" width="50%" clickToClose>
      <div class="layout">
        <div class="layout__header">
          <div class="layout__title">
            <h3>
              Observación Vale
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <textarea-field placeholder="Escriba una observación" id="observacion_vale" name="observacion_vale"
              v-model="form.observacion_vale">
              <span>Observaciones</span>
            </textarea-field>
          </div>
        </div>
        <div class="modal-buttons">
          <button class="btn-danger btn--text" @click="$modal.hide('obs-vale')">
            <i class="fa fa-times"></i><span>Cerrar</span>
          </button>
        </div>
      </div>
    </modal>
    <modal name="dominical-ruta" scrollable reset adaptive resizable height="auto" width="50%" clickToClose>
      <div class="layout">
        <div class="layout__header">
          <div class="layout__title">
            <h3>
              Pago dominical a la ruta
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <textarea-field placeholder="Escriba una observación" id="observaciones"
              v-model="observacion_dominical">
              <span>Observaciones</span>
            </textarea-field>
          </div>
        </div>
        <div class="modal-buttons">
          <button class="btn-success" @click="pagarDominicalRuta">
            <i class="fa fa-save"></i><span>Guardar</span>
          </button>
          <button class="btn-danger btn--text" @click="$modal.hide('dominical-ruta')">
            <i class="fa fa-times"></i><span>Cancelar</span>
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ModalAbono from "./modalAbono.vue";
import Prestamo from '../Prestamo.vue';
import ModalAtraso from './ModalAtraso.vue';
import Amortizaciones from '../Amortizaciones.vue';
// import CreditosAgendados from './CreditosAgendados.vue';
import moment from "moment";
export default {
  components: { ModalAbono, Prestamo, ModalAtraso, Amortizaciones },
  props: {
    parametros: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    puedeCrear: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEditar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeCerrar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeAbrir: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeAbonar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedePagarDominical: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeNoPagar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeRefinanciar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeRenovar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeSaldar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeCrearPrestamos: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeAbonarPrestamosAgendados: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeAsignarFechaMasiva: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedePagarDominicalRuta: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    vale: function () {
      let vale = 0;
      let subtotal = round(parseFloat(this.subtotal), 2);
      if (isNaN(subtotal)) subtotal = 0;
      let prestamo_efectivo = round(parseFloat(this.form.prestamo_efectivo), 2);
      if (isNaN(prestamo_efectivo)) prestamo_efectivo = 0;
      let prestamo_deposito = round(parseFloat(this.form.prestamo_deposito), 2);
      if (isNaN(prestamo_deposito)) prestamo_deposito = 0;
      let prestamo_transferencia = round(parseFloat(this.form.prestamo_transferencia), 2);
      if (isNaN(prestamo_transferencia)) prestamo_transferencia = 0;
      let total_entregado = round(parseFloat(this.form.total_entregado), 2);
      if (isNaN(total_entregado)) total_entregado = 0;
      let gasto = round(parseFloat(this.form.gasto), 2);
      if (isNaN(gasto)) gasto = 0;
      vale = round(subtotal + prestamo_efectivo + prestamo_deposito + prestamo_transferencia - total_entregado - gasto, 2);
      return this.moneyFormat(vale, 2);
    },
    cuotaPromedio: function () {
      let cuota = 0;
      if (this.form.prestamosN.length > 0) {
        for (let i = 0; i < this.form.prestamosN.length; i++) {
          cuota += parseFloat(this.form.prestamosN[i].valor_cuota);
        }
        cuota = round(cuota, 2);
        cuota = cuota / this.form.prestamosN.length;
      }
      this.form.cuota_promedio = cuota;
      return cuota;
    },
    porcCobrado: function () {
      let porcCobrado = 0;
      let total_pagos = parseFloat(this.form.total_pagos);
      if (isNaN(total_pagos)) total_pagos = 0;
      let deberia = parseFloat(this.form.deberia);
      if (isNaN(deberia)) deberia = 0;
      if (deberia == 0) {
        porcCobrado = 0;
      } else {
        porcCobrado = round((total_pagos / deberia) * 100, 2);
      }
      this.form.porc_cobrado = round(porcCobrado, 2);
      return porcCobrado;
    },
    porcRecaudado: function () {
      let porcRecaudado = 0;
      for (let i = 0; i < this.form.prestamosN.length; i++) {
        porcRecaudado += parseFloat(this.form.prestamosN[i].total_pagado);
      }
      porcRecaudado = round(porcRecaudado, 2);
      this.form.porc_recaudado = porcRecaudado;
      return porcRecaudado;
    },
    // deberia: function () {
    //   let deberia = 0;
    //   for (let i = 0; i < this.form.prestamosN.length; i++) {
    //     deberia += parseFloat(this.form.prestamosN[i].valor_cuota);
    //   }
    //   this.form.deberia = deberia;
    //   return deberia;
    // },
    totalPagos: function () {
      let totalPagos = 0;
      for (let i = 0; i < this.form.prestamosN.length; i++) {
        totalPagos += round(parseFloat(this.form.prestamosN[i].pago.valor), 2);
      }
      this.form.total_pagos = round(totalPagos, 2);
      return this.form.total_pagos;
    },
    totalNoPagos: function () {
      let totalNoPagos = 0;
      // for (let i = 0; i < this.form.prestamosN.length; i++) {
      //   totalNoPagos += round(parseFloat(this.form.prestamosN[i].atrasos), 2);
      // }
      totalNoPagos = this.form.prestamosN.filter(item => item.atraso).length;
      this.form.total_no_pagos = totalNoPagos;
      return totalNoPagos;
    },
    totalDominicales: function () {
      let totalDominicales = 0;
      totalDominicales = this.form.prestamosN.filter(item => item.observacion_dominical != '' && item.observacion_dominical).length;
      // for (let i = 0; i < this.form.prestamosN.length; i++) {
      //   totalDominicales += round(parseFloat(this.form.prestamosN[i].pagos_dominicales), 2);
      // }
      this.form.total_dominicales = totalDominicales;
      return totalDominicales;
    },
    totalRecibos: function () {
      let totalRecibos = 0;
      totalRecibos = this.form.prestamosN.length;
      // for (let i = 0; i < this.form.prestamosN.length; i++) {
      //   if (this.form.prestamosN[i].tipo_prestamo === "R") totalRecibos++;
      // }
      this.form.total_recibos = totalRecibos;
      return totalRecibos;
    },
    esFechaFutura: function () {
      // comentar
      // return false;
      if (!this.form.fecha) return true;
      const fechaActual = moment(new Date());
      return moment(this.form.fecha).isAfter(fechaActual);
    },
    subtotal: function () {
      let total = 0;
      let credito = parseFloat(this.form.total_credito);
      if (isNaN(credito)) credito = 0;
      let efectivo = parseFloat(this.form.total_efectivo);
      if (isNaN(efectivo)) efectivo = 0;
      let valeBase = parseFloat(this.form.vale_base);
      if (isNaN(valeBase)) valeBase = 0;
      let deposito = parseFloat(this.form.total_deposito);
      if (isNaN(deposito)) deposito = 0;
      let microseguro = parseFloat(this.form.total_microseguro);
      if (isNaN(microseguro)) microseguro = 0;
      total = round(efectivo + valeBase + microseguro - credito - deposito, 2);
      return total;
    },
  },
  data: function () {
    return {
      selectedPrestamo: null,
      selectedIndexP: -1,
      form: {
        fecha: moment(new Date()).format("YYYY-MM-DD"),
        ruta_id: "",
        search: "",
        // Todos los préstamos
        prestamos: [],
        // Préstamos normales (salen en la tabla principal)
        prestamosN: [],
        // Préstamos normales según el search
        prestamosFilter: [],
        // Préstamos de renovación
        prestamosRN: [],
        // Préstamos de refinanciamiento
        prestamosRF: [],
        // Préstamos creados en la ruta
        prestamosNR: [],
        recaudador_id: "",
        vale_base: 0,
        total_credito: 0,
        total_efectivo: 0,
        total_deposito: 0,
        total_microseguro: 0,
        total_entregado: 0,
        gasto: 0,
        observacion_gasto: "",
        prestamo_efectivo: 0,
        prestamo_deposito: 0,
        prestamo_transferencia: 0,
        cuota_promedio: 0,
        porc_cobrado: 0,
        porc_recaudado: 0,
        deberia: 0,
        total_pagos: 0,
        total_no_pagos: 0,
        total_dominicales: 0,
        total_recibos: 0,
        id: "",
        numero_documento: "",
        estado: 'A',
        saldada: 'N',
        _method: undefined,
        es_masiva: false,
        fecha_masiva: "",
        observacion_vale: ""
      },
      rutas: [],
      selectedRuta: null,
      recaudadores: [],
      selectedRecaudador: null,
      errores: {},
      moneyFormat: moneyFormat,
      money: money,
      moneyNegative: moneyNegative,
      rutaCobros: null,
      tipoPrestamo: null,
      round: round,
      obj: {
        id: "",
        fecha_masiva: ""
      },
      observacion_dominical: ""
    };
  },
  methods: {
    imprimirCierre: function (tipoReporte) {
      const id = this.form.id || this.rutaCobros.id;
      window.open(
        `${url}/rutas-cobros/${id}/${tipoReporte}`,
        "_blank"
      );
    },
    imprimirRecibos: function () {
      const id = this.form.id || this.rutaCobros.id;
      window.open(
        url + "/rutas-cobros/" + id + "/recibos",
        "_blank"
      );
    },
    confirmarGuardar: function () {
      swal({
        title: "¿Desea almacenar la ruta de cobro?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.guardar();
        }
      });
    },
    guardar: function (directo = false) {
      let urlApi = url + "/rutas-cobros";
      if (this.form.id != "") {
        urlApi += "/" + this.form.id;
        this.form._method = "PUT";
      } else this.form._method = undefined;
      return axios
        .post(urlApi, this.form)
        .then(({ data }) => {
          this.errores = {};
          if (this.form.id == "") {
            this.form.id = data.id;
            this.form.numero_documento = data.numero_documento;
          }
          this.cargarPrestamos(data.prestamos);
          if (!directo) {
            swal.fire(
              "La ruta fue almacenada con éxito.",
              "Aviso",
              "success"
            );
          }
        })
        .catch(({ response }) => {
          if (response.status === 422) {
            this.errores = response.data.errors;
            swal.fire("Hay errores en el formulario.", "Aviso", "warning");
          } else {
            swal.fire(
              "Hubo un error, intente nuevamente.",
              "Error",
              "error"
            );
          }
          throw response;
        });
    },
    calcularDeberia: function () {
      let deberia = 0;
      for (let i = 0; i < this.form.prestamosN.length; i++) {
        deberia += parseFloat(this.form.prestamosN[i].valor_cuota);
      }
      // this.form.deberia = deberia;
      return deberia;
    },
    generar: function () {
      if (this.selectedRuta != null && this.form.fecha != "") {
        axios
          .get(url + "/rutas-cobros/prestamos", {
            params: {
              fecha: this.form.fecha,
              ruta_id: this.form.ruta_id,
            },
          })
          .then(({ data }) => {
            let prestamos = data.prestamos;
            this.errores = {};
            this.rutaCobros = data.rutaCobros;
            this.valeRutaAnterior = data.valeRutaAnterior;
            if (this.rutaCobros != null) {
              this.form.id = this.rutaCobros.id;
              this.form.numero_documento = this.rutaCobros.numero_documento;
              this.form.estado = this.rutaCobros.estado;
              this.form.recaudador_id = this.rutaCobros.recaudador_id;
              this.selectedRecaudador = this.rutaCobros.recaudador;
              this.form.saldada = this.rutaCobros.saldada;
              this.form.total_credito = round(this.rutaCobros.total_credito, 2);
              this.form.total_efectivo = round(this.rutaCobros.total_efectivo, 2);
              this.form.total_entregado = round(this.rutaCobros.total_entregado, 2);
              this.form.gasto = round(this.rutaCobros.gasto, 2);
              this.form.observacion_gasto = this.rutaCobros.observacion_gasto;
              this.form.observacion_vale = this.rutaCobros.observacion_vale;
              this.form.total_deposito = round(
                this.rutaCobros.total_deposito,
                2
              );
              this.form.total_microseguro = round(this.rutaCobros.total_microseguro, 2);
              this.form.vale_base = round(this.rutaCobros.vale_base, 2);
              this.form.es_masiva = this.rutaCobros.es_masiva;
              this.form.fecha_masiva = this.rutaCobros.fecha_masiva;
              this.form.deberia = round(this.rutaCobros.deberia, 2);
            }
            else {
              if (this.valeRutaAnterior != null) {
                // this.form.total_efectivo = round(this.valeRutaAnterior, 2);
                this.form.vale_base = round(this.valeRutaAnterior, 2);
              }
            }
            this.cargarPrestamos(prestamos);
            this.calcularTotalesConsignacion();
            if (!this.rutaCobros) {
              const porc_microseguro = this.parametros ? parseFloat(this.parametros.porc_microseguro) : 2;
              this.form.total_microseguro = round(this.form.total_credito * (porc_microseguro / 100), 2);
              this.form.deberia = this.calcularDeberia();
            }
          });
      } else {
        swal.fire("Debe seleccionar una ruta y una fecha.", "Aviso", "warning");
      }
    },
    cargarPrestamos: function (prestamos, esSingular = false) {
      if (!esSingular) {
        this.form.prestamos.splice(0, this.form.prestamos.length);
      }
      let proximoDia = moment(this.form.fecha).add(1, 'days');
      if (proximoDia.day() === 0) { // 0 es domingo
        proximoDia = proximoDia.add(1, 'days'); // Si es domingo, agrega otro día
      }
      for (let i = 0; i < prestamos.length; i++) {
        const element = {
          cliente: {
            descripcion: prestamos[i].cliente.descripcion,
            numero_identificacion: prestamos[i].cliente.numero_identificacion,
            estado: prestamos[i].cliente.estado,
            observacion_cliente: prestamos[i].cliente.observacion_cliente,
          },
          prestamo_id: prestamos[i].id,
          cliente_ruta_cobro_id: prestamos[i].cliente_ruta_cobro_id || null,
          fecha_desembolso: prestamos[i].fecha_desembolso,
          numero_documento: prestamos[i].numero_documento,
          cuotas_canceladas: prestamos[i].cuotas_canceladas,
          cuotas_faltantes: prestamos[i].cuotas_faltantes,
          pagos_dominicales: prestamos[i].pagos_dominicales,
          observacion_dominical: prestamos[i].observacion_dominical,
          atrasos: prestamos[i].atrasos,
          atraso: prestamos[i].atraso,
          porc_multa: prestamos[i].porc_multa || this.parametros.porc_multa,
          estado: prestamos[i].estado,
          estado_descripcion: prestamos[i].estado_descripcion,
          valor: prestamos[i].valor,
          total_pagado: prestamos[i].total_pagado,
          total_pagado_dia: prestamos[i].total_pagado_dia,
          saldo: prestamos[i].saldo,
          valor_cuota: prestamos[i].valor_cuota,
          tipo_prestamo: prestamos[i].tipo_prestamo,
          prestamo_ref: prestamos[i].prestamo_ref,
          periodo: prestamos[i].periodo,
          dia_cobro: prestamos[i].dia_cobro,
          // fecha_proximo_pago: prestamos[i].fecha_proximo_pago || this.getFechaProximoPago(prestamos[i].periodo, prestamos[i].dia_cobro),
          fecha_proximo_pago: prestamos[i].fecha_proximo_pago || proximoDia.format("YYYY-MM-DD"),
          pago: {
            id: null,
            valor: 0,
            efectivo: 0,
            transferencia: 0,
            deposito: 0,
            ref_deposito: "",
            archivo: null,
            url_archivo: null,
            observaciones: "",
            amt_total: 0,
            amt_total_saldo: 0,
            amt_total_a_pagar: 0,
            editar: false,
            cuotas: prestamos[i].cuotas.map((item) => {
              // item['pagada'] = item.saldo == 0,
              item["seleccionada"] = false;
              item["valor_pago"] = 0.0;
              return item;
            }),
          },
        };
        // Si no es periodo diario y no tiene fecha de próximo pago en db
        if (element.periodo != 'D' && !prestamos[i].fecha_proximo_pago)
          element.fecha_proximo_pago = this.getFechaProximoPago(element);
        if (prestamos[i].pago) {
          element.pago = {
            id: prestamos[i].pago.id,
            valor: prestamos[i].pago.valor,
            efectivo: prestamos[i].pago.efectivo,
            transferencia: prestamos[i].pago.transferencia,
            deposito: prestamos[i].pago.deposito,
            ref_deposito: prestamos[i].pago.referencia_deposito,
            archivo: null,
            url_archivo: prestamos[i].pago.archivo_path,
            observaciones: prestamos[i].pago.observaciones,
            // fecha_proximo_pago: prestamos[i].pago.fecha_proximo_pago || moment(this.form.fecha).add(1, 'days').format("YYYY-MM-DD"),
            amt_total: 0,
            amt_total_saldo: 0,
            amt_total_a_pagar: 0,
            editar: true,
            cuotas: prestamos[i].cuotas.map((item) => {
              item["total_pagado"] = item.abono_id
                ? round(
                  parseFloat(item.total_pagado) -
                  parseFloat(item.valor_abono),
                  2
                )
                : round(parseFloat(item.total_pagado), 2);
              item["seleccionada"] = item.abono_id != null;
              item["valor_pago"] = item.valor_abono || 0.0;
              return item;
            }),
            // cuotas: [],
          };
        }
        if (esSingular) {
          return element;
        }
        this.form.prestamos.push(element);
      }
      this.filtrarPrestamos();
      this.inputPrestamo();
    },
    getFechaProximoPago: function (params) {
      const { periodo, dia_cobro } = params;
      if (periodo == 'S') {
        let fechaRuta = moment(this.form.fecha);
        let fecha = moment(this.form.fecha).day(dia_cobro);
        if (fecha.isSameOrBefore(fechaRuta)) {
          fecha.add(1, 'week');
        }
        return fecha.format("YYYY-MM-DD");
      }
      return params.fecha_proximo_pago;
    },
    filtrarPrestamos: function () {
      this.form.prestamosRN = this.form.prestamos.filter(item => {
        return item.tipo_prestamo == 'RN' && item.fecha_desembolso == this.form.fecha;
      });
      this.form.prestamosRF = this.form.prestamos.filter(item => {
        return item.tipo_prestamo == 'RF' && item.fecha_desembolso == this.form.fecha;
      });
      this.form.prestamosNR = this.form.prestamos.filter(item => {
        return (item.tipo_prestamo == 'NR' || item.tipo_prestamo == 'N') && item.fecha_desembolso == this.form.fecha;
      });
      // this.form.prestamosN = this.form.prestamos.filter(item => {
      //   return item.tipo_prestamo == 'N' || ((item.tipo_prestamo == 'RN' || item.tipo_prestamo == 'RF' || item.tipo_prestamo == 'NR') && item.fecha_desembolso != this.form.fecha);
      // });
      this.form.prestamosN = [...this.form.prestamos];
      this.search();
    },
    inputRecaudador: function () {
      if (this.selectedRecaudador != null)
        this.form.recaudador_id = this.selectedRecaudador.id;
      else this.form.recaudador_id = "";
    },
    onSearchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inputRuta: function () {
      if (this.selectedRuta != null) this.form.ruta_id = this.selectedRuta.id;
      else this.form.ruta_id = "";
    },
    onSearchRutas: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/rutas?search=" + search, true);
      xmlhttp.send();
    },
    abrirModalAbonos: function (indexP) {
      const realIndex = this.getRealIndex(indexP);
      this.selectedIndexP = realIndex;
      this.selectedPrestamo = JSON.parse(
        JSON.stringify(this.form.prestamos[realIndex])
      );
      this.selectedPrestamo.pago.cuotas.splice(
        0,
        this.selectedPrestamo.pago.cuotas.length
      );
      // this.selectedPrestamo = this.form.prestamos[indexP];
      this.$modal.show("modalAbonos");
    },
    inputModalAbono: function (item) {
      let urlApi = url + "/rutas-cobros/guardar-abonos";
      axios
        .post(urlApi, item)
        .then(({ data }) => {
          this.errores = {};
          const prestamos = [data.prestamo];
          const prestamo = this.cargarPrestamos(prestamos, true);
          this.form.prestamos.splice(this.selectedIndexP, 1, prestamo);
          this.filtrarPrestamos();
          this.inputPrestamo();
          this.$modal.hide("modalAbonos");
          swal.fire(
            "Los abonos fueron almacenados con éxito.",
            "Aviso",
            "success"
          );
        })
        .catch(({ response }) => {
          if (response.status === 422) {
            this.errores = response.data.errors;
            swal.fire("Hay errores en el formulario.", "Aviso", "warning");
          } else {
            swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
          }
        });
    },
    limpiar: function () {
      swal({
        title: "¿Desea limpiar la pantalla?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.value) {
          return;
        }
        location.reload();
      });
    },
    inputPrestamo: function () {
      let prestamo_efectivo = 0;
      let prestamo_deposito = 0;
      let prestamo_transferencia = 0;
      this.form.prestamosN.map((item) => {
        prestamo_efectivo += round(parseFloat(item.pago.efectivo), 2);
        prestamo_deposito += round(parseFloat(item.pago.deposito), 2);
        prestamo_transferencia += round(parseFloat(item.pago.transferencia), 2);
      });
      this.form.prestamo_efectivo = prestamo_efectivo;
      this.form.prestamo_deposito = prestamo_deposito;
      this.form.prestamo_transferencia = prestamo_transferencia;
    },
    validarClienteActivoRenovacion: function (prestamo) {
      if (prestamo && prestamo.cliente && prestamo.cliente.estado !== 'A') {
        const observacion = prestamo.cliente.observacion_cliente
          ? `Motivo de anulación: ${prestamo.cliente.observacion_cliente}`
          : "No se registró una observación de anulación.";
        swal.fire(
          "Aviso",
          `Cliente inactivo, no se puede realizar la renovación.\n\n ${observacion}`,
          "warning"
        );
        return false;
      }
      return true;
    },
    abrirModalPrestamo: async function (indexP, tipo) {
      if (tipo !== 'NR') {
        this.selectedIndexP = this.getRealIndex(indexP);
        const selectedPrestamo = JSON.parse(
          JSON.stringify(this.form.prestamos[this.selectedIndexP])
        );
        if (tipo === 'RN' && !this.validarClienteActivoRenovacion(selectedPrestamo)) {
          return;
        }
        this.selectedPrestamo = selectedPrestamo;
        const { existe_pago_futuro } = await this.existePagoFuturo();
        if (existe_pago_futuro) {
          return;
        }
      } else {
        this.selectedIndexP = -1;
        this.selectedPrestamo = null;
      }
      this.tipoPrestamo = tipo;
      this.$modal.show("prestamo");
    },
    existePagoFuturo: async function () {
      try {
        const { data } = await axios.get(url + "/rutas-cobros/existe-pago-futuro", {
          params: {
            ruta_cobro_id: this.form.id,
            ruta_id: this.form.ruta_id,
            prestamo_id: this.selectedPrestamo.prestamo_id
          },
        });
        if (data.existe_pago_futuro) {
          swal.fire("Aviso", "No se puede realizar esta acción si el préstamo tiene abonos en fechas posteriores.", "warning");
        }
        return data;
      } catch (error) {
        swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
        return {
          'existe_pago_futuro': true
        };
      }
    },
    abonoTotalPrestamo: function () {
      let urlApi = url + "/rutas-cobros/guardar-abonos/true/" + this.tipoPrestamo;
      axios
        .post(urlApi, this.selectedPrestamo)
        .then(({ data }) => {
          this.errores = {};
          const prestamos = [data.prestamo];
          const prestamo = this.cargarPrestamos(prestamos, true);
          this.form.prestamos.splice(this.selectedIndexP, 1, prestamo);
          this.filtrarPrestamos();
          this.inputPrestamo();
        })
        .catch(({ response }) => {
          if (response.status === 422) {
            this.errores = response.data.errors;
            swal.fire("Hay errores en el formulario.", "Aviso", "warning");
          } else {
            swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
          }
        });
    },
    abrirModalDominical: function (indexP) {
      const realIndex = this.getRealIndex(indexP);
      // if (this.existenAbonos(realIndex)) {
      //   swal("No puede realizar el pago dominical debido a que existen cuotas abonadas", 'Advertencia', 'warning');
      //   return;
      // }
      this.selectedIndexP = realIndex;
      this.selectedPrestamo = JSON.parse(
        JSON.stringify(this.form.prestamos[realIndex])
      );
      this.$modal.show("dominical");
    },
    openModalGasto: function () {
      this.$modal.show("gasto");
    },
    openModalObsVale: function () {
      this.$modal.show("obs-vale");
    },
    inputDominical: function () {
      let urlApi = url + "/rutas-cobros/pago-dominical";
      axios
        .post(urlApi, this.selectedPrestamo)
        .then(({ data }) => {
          this.$modal.hide("dominical");
          const prestamo = this.cargarPrestamos([data.crc], true);
          this.form.prestamos.splice(this.selectedIndexP, 1, prestamo);
          this.filtrarPrestamos();
          swal.fire(
            "El pago dominical se ha almacenado con éxito.",
            "Aviso",
            "success"
          );
        })
        .catch(({ response }) => {
          if (response.status === 422) {
            this.errores = response.data.errors;
            swal.fire("Hay errores en el formulario.", "Aviso", "warning");
          } else {
            swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
          }
        });
    },
    existenAbonos: function (indexP) {
      const cuotasSeleccionadas = this.form.prestamos[indexP].pago.cuotas.filter(item => item.seleccionada);
      return cuotasSeleccionadas.length > 0;
    },
    abrirModalAtraso: function (indexP) {
      const realIndex = this.getRealIndex(indexP);
      this.selectedIndexP = realIndex;
      this.selectedPrestamo = JSON.parse(JSON.stringify(this.form.prestamos[realIndex]));
      this.$modal.show("modalAtraso");
    },
    registrarAtraso: function () {
      let urlApi = url + "/rutas-cobros/atraso";
      axios
        .post(urlApi, this.selectedPrestamo)
        .then(({ data }) => {
          this.$modal.hide("modalAtraso");
          const prestamos = [data.prestamo];
          const prestamo = this.cargarPrestamos(prestamos, true);
          // this.form.prestamos.splice(realIndex, 1, prestamo);
          this.form.prestamos.splice(this.selectedIndexP, 1, prestamo);
          this.filtrarPrestamos();
          swal.fire(
            "Se ha registrado el atraso con éxito.",
            "Aviso",
            "success"
          );
        })
        .catch(({ response }) => {
          if (response.status == 409) {
            const msg = response.data.error;
            swal("Error", msg, "error");
          } else if (response.status === 422) {
            this.errores = response.data.errors;
            swal.fire("Hay errores en el formulario.", "Aviso", "warning");
          } else {
            swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
          }
        });
      // });
    },
    revertirAtraso: function (indexP) {
      const realIndex = this.getRealIndex(indexP);
      swal({
        title: "¿Desea revertir el atraso?",
        text: "Se recalcularán las cuotas.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.value) {
          return;
        }
        let urlApi = url + "/rutas-cobros/revertir-atraso";
        axios
          .post(urlApi, this.form.prestamos[realIndex])
          .then(({ data }) => {
            const prestamos = [data.prestamo];
            const prestamo = this.cargarPrestamos(prestamos, true);
            this.form.prestamos.splice(realIndex, 1, prestamo);
            this.filtrarPrestamos();
            swal.fire(
              "Se ha registrado el atraso con éxito.",
              "Aviso",
              "success"
            );
          })
          .catch(({ response }) => {
            if (response.status == 409) {
              const msg = response.data.error;
              swal("Error", msg, "error");
            } else if (response.status === 422) {
              this.errores = response.data.errors;
              swal.fire("Hay errores en el formulario.", "Aviso", "warning");
            } else {
              swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
            }
          });
      });
    },
    abrirModalAmortizaciones: function (indexP) {
      const realIndex = this.getRealIndex(indexP);
      this.selectedIndexP = realIndex;
      this.selectedPrestamo = JSON.parse(JSON.stringify(this.form.prestamos[realIndex]));
      this.$modal.show("amortizaciones");
    },
    getEstadoParse: function (estado) {
      const objeto = {
        'A': 'Generado',
        'C': 'Cerrado'
      };
      return objeto[estado] || '';
    },
    getEstadoColor: function (estado) {
      const objeto = {
        'A': 'noti-info',
        'C': 'noti-danger'
      };
      return objeto[estado] || '';
    },
    aperturaCierrerRuta: function (valor) {
      const msg = valor === 'C' ? 'El cierre' : 'La apertura';
      swal({
        title: "¿Desea realizar " + msg.toLocaleLowerCase() + " de la ruta?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.value) {
          return;
        }
        // Guardar datos en pantalla, para luego aperturar/cerrar la ruta
        this.guardar(true)
          .then(() => {
            let urlApi = url + "/rutas-cobros/apertura-cierre/" + this.form.id + "/" + valor;
            axios
              .post(urlApi)
              .then(({ data }) => {
                const msg = valor === 'C' ? 'El cierre' : 'La apertura';
                this.form.estado = data;
                swal.fire(
                  msg + " de la ruta se ha almacenado con éxito.",
                  "Aviso",
                  "success"
                );
              })
              .catch(({ response }) => {
                if (response.status === 422) {
                  this.errores = response.data.errors;
                  swal.fire("Hay errores en el formulario.", "Aviso", "warning");
                } else if (response.status === 409) {
                  const msg = response.data.error;
                  swal("Error", msg, "error");
                } else {
                  swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
                }
              });
          })
          .catch((error) => {
            swal('Error', 'Hubo un error al guardar la ruta', 'error');
          });

      });
    },
    getColorP: function (p) {
      if (!p.cliente_ruta_cobro_id)
        return '';
      let deposito = round(parseFloat(p.pago.deposito), 2);
      if (isNaN(deposito)) deposito = 0;
      if (p.atraso)
        return 'bg-atraso';
      if (p.observacion_dominical != '' && p.observacion_dominical != null)
        return 'bg-dominical';
      if (this.tieneRenovacion(p.prestamo_id))
        return 'bg-renovacion';
      if (this.tieneRefinanciamiento(p.prestamo_id))
        return 'bg-refinanciacion';
      if (deposito > 0)
        return 'bg-deposito';
      if (p.pago.cuotas.filter(item => item.saldo == '0.00').length > 1)
        return 'bg-abonos';
      return '';
    },
    tieneRenovacion: function (prestamo_id) {
      return this.form.prestamosRN.some(item => item.prestamo_ref.id == prestamo_id);
    },
    tieneRefinanciamiento: function (prestamo_id) {
      return this.form.prestamosRF.some(item => item.prestamo_ref.id == prestamo_id);
    },
    calcularTotalesConsignacion: function () {
      this.form.total_credito = this.form.prestamos.filter(item => item.fecha_desembolso == this.form.fecha)
        .reduce((acum, current) => {
          return acum += parseFloat(current.valor);
        }, 0);

      // this.form.total_microseguro = this.form.total_microseguro ? this.form.total_microseguro : round(this.form.total_credito * (porc_microseguro / 100), 2);
    },
    search: function () {
      const expresion = new RegExp(`${this.form.search}.*`, "i");
      if (this.form.search) {
        this.form.prestamosFilter = this.form.prestamosN.filter(item => expresion.test(item.cliente.descripcion) || expresion.test(item.cliente.numero_identificacion));
      } else {
        this.form.prestamosFilter = [...this.form.prestamosN];
      }
    },
    actualizarPrestamos: function () {
      axios
        .get(url + "/rutas-cobros/actualizar-prestamos-ruta", {
          params: {
            fecha: this.form.fecha,
            ruta_id: this.form.ruta_id,
            ruta_cobro_id: this.form.id
          },
        })
        .then(({ data }) => {
          const prestamos = data.prestamos;
          this.errores = {};
          this.cargarPrestamos(prestamos);
          this.calcularTotalesConsignacion();
          swal.fire("Aviso", "Deber guardar la ruta de cobro para poder abonar los créditos agregados", "warning");
        }).catch(({ response }) => {
          if (response.status === 422) {
            this.errores = response.data.errors;
            swal.fire("Hay errores en el formulario.", "Aviso", "warning");
          } else {
            swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
          }
        });
    },
    getRealIndex: function (index) {
      return this.form.prestamos.findIndex(item => item.prestamo_id == this.form.prestamosFilter[index].prestamo_id);
    },
    saldar: function () {
      swal({
        title: "¿Desea saldar la ruta de cobro?",
        text: "Se abonará una cuota a todos los préstamos",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          const urlApi = url + `/rutas-cobros/saldar-ruta/${this.form.id}`;
          axios
            .post(urlApi)
            .then(({ data }) => {
              this.form.saldada = 'S';
              this.cargarPrestamos(data.prestamos);
              swal.fire(
                "La ruta fue saldada con éxito.",
                "Aviso",
                "success"
              );
            })
            .catch(({ response }) => {
              if (response.status == 409) {
                this.form.saldada = 'S';
                const msg = response.data.error;
                swal("Error", msg, "error");
              } else {
                swal.fire(
                  "Hubo un error, intente nuevamente.",
                  "Error",
                  "error"
                );
              }
            });
        }
      });
    },
    abrirModalPagarDominicalRuta: function () {
      this.observacion_dominical = "";
      this.$modal.show("dominical-ruta");
    },
    pagarDominicalRuta: function () {
      if (!this.observacion_dominical) {
        swal.fire("Error", "Debe ingresar una observación", "error");
        return;
      }
      swal({
        title: "¿Desea realizar el pago dominical de la ruta?",
        text: "Se eliminarán los abonos de la ruta, se recalcularán los préstamos y se marcarán como dominical.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          const urlApi = url + `/rutas-cobros/pago-dominical-ruta/${this.form.id}`;
          const params = {
            observacion_dominical: this.observacion_dominical
          };
          axios
            .post(urlApi, params)
            .then(({ data }) => {
              this.form.saldada = 'S';
              this.cargarPrestamos(data.prestamos);
              this.$modal.hide("dominical-ruta");
              swal.fire(
                "El pago dominical de la ruta fue realizado con éxito.",
                "Aviso",
                "success"
              );
            })
            .catch(({ response }) => {
              if (response.status == 409) {
                const msg = response.data.error;
                swal("Error", msg, "error");
              } else {
                swal.fire(
                  "Hubo un error, intente nuevamente.",
                  "Error",
                  "error"
                );
              }
            });
        }
      });
    },
    guardarPrestamo: function (prestamo) {
      if (this.tipoPrestamo !== 'NR') {
        this.abonoTotalPrestamo();
      }
      const prestamos = [prestamo];
      const prestamoFormat = this.cargarPrestamos(prestamos, true);
      this.form.prestamos.push(prestamoFormat);
      this.guardar(true)
        .then(() => {
          this.calcularTotalesConsignacion();
          this.$modal.hide('prestamo');
        })
        .catch((error) => {
          swal('Error', 'Hubo un error al guardar la ruta', 'error');
        });
    },
    abrirModalAuditoria: function () {
      this.$modal.show("auditorias");
    },
    mostrarCreditosAgendados: function () {
      this.$modal.show("clientes-agendados");
    },
    existenDuplicados: function (creditos, nuevosPrestamosId) {
      const idPrestamos = new Set(creditos.map(item => item.prestamo_id));
      const setNuevos = new Set(nuevosPrestamosId);
      for (const item of idPrestamos) {
        if (setNuevos.has(item)) {
          return true; // Se encontró un elemento repetido
        }
      }
      return false; // No hay elementos repetidos
    },
    agregarCreditosAgendados: function (futuros) {
      const futurosId = futuros.map(item => item.prestamo.id);
      const existenDuplicados = this.existenDuplicados(this.form.prestamosN, futurosId);
      if (existenDuplicados) {
        swal.fire(
          "Existen préstamos que están agregados a la ruta.",
          "Advertencia",
          "warning"
        );
        return;
      }
      const urlApi = `${url}/rutas-cobros/get-prestamo-normal-format`;
      axios
        .get(urlApi, {
          params: {
            'prestamosId': futurosId
          }
        })
        .then(({ data }) => {
          const { prestamos } = data;
          for (let i = 0; i < prestamos.length; i++) {
            const prestamoFormat = this.cargarPrestamos([prestamos[i]], true);
            console.log(prestamoFormat);
            this.form.prestamos.unshift(prestamoFormat);
          }
          this.filtrarPrestamos();
          this.inputPrestamo();
          this.$modal.hide("clientes-agendados");
          swal.fire(
            "Aviso",
            "Deber guardar la ruta de cobro para poder abonar los créditos agregados",
            "warning"
          );
        })
        .catch(error => {
          console.log(error);
          swal('Error', 'Hubo un error al cargar los préstamos.', 'error');
        });
    },
    mostrarModalFechaMasiva: function () {
      this.obj.id = this.form.id;
      this.obj.fecha_masiva = this.form.fecha_masiva;
      this.$modal.show("fechaMasiva");
    },
    asignarFechaMasiva: function () {
      swal({
        title: "¿Desea asignar masivamente una fecha de próximo pago?",
        text: "Se actualizará la fecha de próximo pago a todos los créditos.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          const urlApi = url + `/rutas-cobros/asignar-masiva-fecha-pago/${this.obj.id}`;
          axios
            .post(urlApi, this.obj)
            .then(({ data }) => {
              this.form.es_masiva = true;
              this.form.fecha_masiva = this.obj.fecha_masiva;
              this.cargarPrestamos(data.prestamos);
              swal.fire(
                "Éxito",
                "La asignación masiva de fecha de próximo pago fue realizada con éxito.",
                "success"
              );
              this.$modal.hide("fechaMasiva");
            })
            .catch(({ response }) => {
              swal.fire(
                "Hubo un error, intente nuevamente.",
                "Error",
                "error"
              );
            });
        }
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/cobros/RutaCobros.vue